<template>
    <ElTooltip v-bind="$attrs">
        <template #content>
            <div
                v-if="content || $slots.content"
                :style="maxWidth ? 'max-width:'+maxWidth+'px' : ''">
                <slot name="content">
                    {{ content }}
                </slot>
            </div>
        </template>
        <template #default>
            <slot>
                <font-awesome-icon
                    class="pointer"
                    fixed-width
                    :icon="icon"
                    @click="$emit('click', $event)" />
            </slot>
        </template>
    </ElTooltip>
</template>

<script>

export default {
    name: "BaseTooltip",
    props: {
        content: {
            type: String,
            default: ""
        },
        icon: {
            type: String,
            default: "circle-info"
        },
        size: {
            type: String,
            default: "md",
            validator: function (value) {
                return ["xl", "lg", "md", "sm", "xs"].indexOf(value) !== -1
            }
        }
    },
    computed: {
        maxWidth() {
            switch (this.size) {
                case "xl":
                    return 600
                case "lg":
                    return 500
                case "md":
                    return 400
                case "sm":
                    return 300
                case "xs":
                    return 200
                default:
                    return null
            }
        }
    }
}
</script>

<style scoped>

</style>
